<template>
    <div>
        <div
            class="planning-wrapper"
            :class="{ 'expose': expose }"
            @dragover.prevent="handleDragOver"
            @drop.prevent="handleDrop"
            @mouseover="handleMouseOver"
        >
            <div class="planning-button-bar" v-if="!expose">
                <button
                    type="button"
                    :title="trans('Project view')"
                    class="bar-button"
                    :class="{ active: mode === 'project' }"
                    :disabled="mode === 'project'"
                    @click="changeMode({ mode: 'project' })"
                >
                    <i class="icofont-chart-flow-2"></i>
                </button>
                <button
                    type="button"
                    :title="trans('People view')"
                    class="bar-button"
                    :class="{ active: mode === 'person' }"
                    :disabled="mode === 'person'"
                    @click="changeMode({ mode: 'person' })"
                >
                    <i class="icofont-user-alt-1"></i>
                </button>
                <button
                    type="button"
                    :title="trans('Team view')"
                    class="bar-button"
                    :class="{ active: mode === 'team' }"
                    :disabled="mode === 'team'"
                    @click="changeMode({ mode: 'team' })"
                >
                    <i class="icofont-people"></i>
                </button>
                <button
                    type="button"
                    :title="trans('Equipment view')"
                    class="bar-button"
                    :class="{ active: mode === 'equipment' }"
                    :disabled="mode === 'equipment'"
                    @click="changeMode({ mode: 'equipment' })"
                >
                    <i class="icofont-vehicle-cement"></i>
                </button>
                <button
                    type="button"
                    :title="trans('Personscapacity view')"
                    class="bar-button"
                    :class="{ active: mode === 'capacityPerson' }"
                    :disabled="mode === 'capacityPerson'"
                    @click="changeMode({ mode: 'capacityPerson' })"
                >
                    <i class="background-icon icofont-user-alt-1"></i>
                    <i class="icofont-chart-bar-graph"></i>
                </button>
                <button
                    type="button"
                    :title="trans('Day tasks')"
                    class="bar-button"
                    :class="{ active: mode === 'dailyPlanned' }"
                    :disabled="mode === 'dailyPlanned'"
                    @click="changeMode({ mode: 'dailyPlanned' })"
                    v-if="['bW7e4l', 'pMFLZR', 'B53eKS'].includes(slug)"
                >
                    <i class="icofont-clip-board"></i>
                </button>
                <button
                    type="button"
                    :title="trans('Project persons')"
                    class="bar-button"
                    :class="{ active: mode === 'projectPersons' }"
                    :disabled="mode === 'projectPersons'"
                    @click="changeMode({ mode: 'projectPersons' })"
                    v-if="['bW7e4l', 'pMFLZR', 'B53eKS'].includes(slug)"
                >
                    <i class="icofont-sub-listing"></i>
                </button>
                <button
                    type="button"
                    :title="trans('Team lead')"
                    class="bar-button"
                    :class="{ active: mode === 'teamLead' }"
                    :disabled="mode === 'teamLead'"
                    @click="changeMode({ mode: 'teamLead' })"
                    v-if="['bW7e4l', 'pMFLZR', 'B53eKS'].includes(slug)"
                >
                    <i class="icofont-user-suited"></i>
                </button>
                <button type="button" class="bar-date-button" @click="setPreviousDates()">
                    <i class="icofont-simple-left"></i>
                </button>
            </div>

            <template
                 v-if="mode === 'dailyPlanned'"
            >
                <div class="calendar" >
                    <div class="inline-flex">
                        <corner-cell v-if="mode" :mode="mode"></corner-cell>
                        <top-row-dates></top-row-dates>
                    </div>
                    <daily-planned-component/>
                </div>

            </template>
            <template
                 v-else-if="mode === 'projectPersons'"
            >
                <div class="calendar" >
                    <div class="inline-flex">
                        <corner-cell v-if="mode" :mode="mode"></corner-cell>
                        <top-row-dates></top-row-dates>
                    </div>
                    <project-persons-component/>
                </div>

            </template>
            <template
                 v-else-if="mode === 'teamLead'"
            >
                <div class="calendar" >
                    <team-lead-planning-component/>
                </div>

            </template>
            <template v-else>
                <RecycleScroller
                    :items="rows"
                    :min-item-size="50"
                    size-field="height"
                    ref="calendar"
                    class="calendar"
                    keyField="index"
                >
                    <template #before>
                        <div>
                            <div class="inline-flex">
                                <corner-cell v-if="mode" :mode="mode"></corner-cell>
                                <top-row-dates></top-row-dates>
                            </div>
                            <company-capacity-row-component
                                v-if="mode && mode === 'capacityPerson'"
                            ></company-capacity-row-component>
                        </div>
                    </template>

                    <!-- Update Comment, deleted :active="active" from the row component -->
                    <template v-slot="{ item }">
                        <row :row="item" :currentZoom="currentZoom"></row>
                    </template>
                </RecycleScroller>
            </template>

            <div class="right-control-panel" v-if="!expose">
                <control-panel-extra-component
                    :show="controlPanelExtra.show"
                    @close="controlPanelExtra.show = false"
                >
                    <template v-slot:title>{{ controlPanelExtra.title }}</template>
                    <component v-bind:is="controlPanelExtra.component"></component>
                </control-panel-extra-component>

                <div class="planning-button-bar">
                    <button type="button" class="bar-button primary" @click="openPlanningForm">
                        <i class="icofont-plus"></i>
                    </button>

                    <button
                        type="button"
                        class="bar-button"
                        v-if="mode === 'project' || mode === 'dailyPlanned' || mode === 'teamLead' || mode === 'projectPersons'"
                        @click="toggleControlPanelExtra('personListComponent', trans('Employees'))"
                    >
                        <i class="icofont-user-alt-1"></i>
                    </button>

                    <button
                        type="button"
                        class="bar-button"
                        v-if="mode === 'project' || mode === 'dailyPlanned' || mode === 'teamLead' || mode === 'projectPersons'"
                        @click="toggleControlPanelExtra('equipmentListComponent', trans('Equipments'))"
                    >
                        <i class="icofont-vehicle-cement"></i>
                    </button>

                    <button
                        type="button"
                        class="bar-button"
                        v-if="mode === 'person' || mode === 'equipment' || mode === 'team' || mode === 'capacityPerson'"
                        @click="toggleControlPanelExtra('taskListComponent', trans('Tasks'))"
                    >
                        <i class="icofont-tasks-alt"></i>
                    </button>
                    <button
                        type="button"
                        class="bar-button"
                        @click="toggleControlPanelExtra('filterSettingsComponent', 'FILTER')"
                    >
                        <i class="icofont-filter"></i>
                    </button>

                    <button type="button" class="bar-button" @click="zoomOut()">
                        <i class="icofont-ui-zoom-out"></i>
                    </button>
                    <button type="button" class="bar-button" @click="zoomIn()">
                        <i class="icofont-ui-zoom-in"></i>
                    </button>

                    <button
                        type="button"
                        class="bar-button"
                        v-if="mode !== 'capacityPerson'"
                        @click="toggleControlPanelExtra('pdfSettingsComponent', 'PDF')"
                    >
                        <i class="icofont-file-pdf"></i>
                    </button>

                    <button type="button" class="bar-date-button" @click="setNextDates()">
                        <i class="icofont-simple-right"></i>
                    </button>
                </div>
            </div>
            <div class="drag-info-wrapper">
                <div class="drag-info"></div>
            </div>
        </div>
        <update-repeated-slots-component
            v-if="updateRepeatedSlotsModal.active"
            :slot_id="updateRepeatedSlotsModal.slot_id"
            :all_update_option="updateRepeatedSlotsModal.all_update_option"
            @close="resetDragChanges"
            @update="updateRepeatedSlots"
        ></update-repeated-slots-component>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import cornerCell from './CornerCellComponent';
import topRowDates from './TopRowDatesComponent';
import row from './RowComponent';
import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import controlPanelExtraComponent from './ControlPanelExtraComponent';
import personListComponent from './control-panel-extra/PersonListComponent';
import equipmentListComponent from './control-panel-extra/EquipmentListComponent';
import taskListComponent from './control-panel-extra/TaskListComponent';
import pdfSettingsComponent from './control-panel-extra/PdfSettingsComponent';
import filterSettingsComponent from './control-panel-extra/FilterSettingsComponent';
import { emitter } from '../../plugins/Mitt';
import { calculateDragChanges } from '../../stores/planning/calculateDragChanges';
import UpdateRepeatedSlotsComponent from '../schedule/widgets/UpdateRepeatedSlotsComponent.vue';
import { isEmpty } from 'lodash';
import CompanyCapacityRowComponent from './capacity/CompanyCapacityRowComponent';
import DailyPlannedComponent from "./daily-planned/DailyPlannedComponent.vue";
import ProjectPersonsComponent from "./project-persons/ProjectPersonsComponent.vue";
import TeamLeadPlanningComponent from "./team-lead/TeamLeadPlanningComponent.vue";

export default {
    components: {
        ProjectPersonsComponent,
        DailyPlannedComponent,
        CompanyCapacityRowComponent,
        cornerCell,
        topRowDates,
        row,
        RecycleScroller,
        controlPanelExtraComponent,
        personListComponent,
        equipmentListComponent,
        taskListComponent,
        pdfSettingsComponent,
        filterSettingsComponent,
        UpdateRepeatedSlotsComponent,
        TeamLeadPlanningComponent,
    },
    props: {
        expose: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    data() {
        return {
            slug: window.slug,
            controlPanelExtra: {
                show: false,
                component: null,
                title: '',
            },
            dragInfo: {
                day: null,
                dragOverTime: null,
                itemId: null,
            },
            updateRepeatedSlotsModal: {
                active: false,
                slot_id: null,
                all_update_option: false,
            },
            optionConfirmedRepeatedSlotsInModal: false,
            updateRepeatedSlotSetting: '',

            // Scrolling
            delayAtTop: false,
            delayTimer: null
        };
    },
    computed: {
        ...mapState('planning', ['mode', 'rows', 'runwayRows', 'currentZoom', 'dragStartInfo', 'dates']),
    },
    methods: {
        ...mapActions('planning', [
            'initCalendar',
            'loadMoreRows',
            'setPreviousDates',
            'setNextDates',
            'addSlot',
            'zoomIn',
            'zoomOut',
            'changeMode',
            'changeSort',
            'setDraggingData',
            'persistDraggingData',
            'requestItemSlots',
        ]),
        ...mapActions('planningFilter',[
            'loadPlanningFilter'
        ]),
        handleScroll(e) {
            const { target } = e;

            const currentScroll = target.scrollTop;
            const scrollableDistance = Math.max(0, target.scrollHeight - target.offsetHeight);

            if (currentScroll >= scrollableDistance - 500) {
                this.loadMoreRows();
            }
        },
        handleDragOver($event) {
            const target = $event.target.closest('.planning-droparea');

            if (!target) {
                return;
            }

            const date = target.dataset.date;
            const hour = target.dataset.hour ?? null;
            const itemId = parseInt(target.dataset.itemid);

            if (!date || !itemId) {
                return;
            }

            const dragInfoDate = this.dragInfo.date;
            const dragInfoItemId = this.dragInfo.itemId;
            const dragOverTimeStart = this.dragInfo.dragOverTime;

            let dragOverTime = null;
            if (hour !== null) {
                const xPosition = $event.clientX - target.getBoundingClientRect().left; //x position within the element.
                const xRelativePosition = xPosition / target.getBoundingClientRect().width;
                const minutes = Math.ceil((60 * xRelativePosition) / 5) * 5;
                dragOverTime = ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2);
                this.dragInfo.dragOverTime = dragOverTime;
            }

            // Check here on dragOverTime
            if (
                dragInfoDate === date &&
                dragInfoItemId === itemId &&
                dragOverTimeStart === dragOverTime
            ) {
                return;
            }

            this.dragInfo.date = date;
            this.dragInfo.itemId = itemId;

            this.setVuexDraggingData(
                this.dragInfo.date,
                this.dragInfo.itemId,
                this.dragInfo.dragOverTime,
            );
        },
        setVuexDraggingData: _.throttle(function (date, itemId, dragOverTime) {
            this.setDraggingData({
                date: date,
                itemId: itemId,
                dragOverTime: dragOverTime,
            });
        }, 200),
        handleDrop() {
            if (isEmpty(this.dragStartInfo)) {
                return;
            }
            const date = this.dragInfo.date;
            const itemId = this.dragInfo.itemId;
            const dragOverTime = this.dragInfo.dragOverTime;

            const [slots] = calculateDragChanges(
                this.$store.state.planning,
                date,
                itemId,
                dragOverTime,
            );

            const [slotId] = Object.keys(slots);
            const slot = slots[slotId];
            const url = route('planning.schedule-slots', slotId);

            const taskId = slot.task_id;
            if (slot.repeated_settings_id && !this.optionConfirmedRepeatedSlotsInModal) {
                this.updateRepeatedSlotsModal.active = true;
                emitter.emit('hide-slot-hover-info');
                emitter.emit('hide-day-hover-info');
                return;
            }
            let assignedPersons = [];
            let assignedEquipments = [];
            let assignedTeams = {};

            Object.values(slot.persons).forEach((person) => {
                if (person.teams.length !== 0) {
                    const teamId = person.teams[0];
                    assignedTeams[teamId] = assignedTeams[teamId] ?? {}; // Ensure object exists
                    assignedTeams[teamId]['persons'] = assignedTeams[teamId]['persons'] ?? {}; // Ensure 'persons' exists
                    assignedTeams[teamId]['persons'][person.personId] = true;
                    return;
                }
                assignedPersons.push(person.personId);
            });
            Object.values(slot.equipments).forEach((equipment) => {
                if (equipment.teams.length !== 0) {
                    const teamId = equipment.teams[0];
                    assignedTeams[teamId] = assignedTeams[teamId] ?? {}; // Ensure object exists
                    assignedTeams[teamId]['equipments'] = assignedTeams[teamId]['equipments'] ?? {}; // Ensure 'equipments' exists
                    assignedTeams[teamId]['equipments'][equipment.equipmentId] = true;
                    return;
                }
                assignedEquipments.push(equipment.equipmentId);
            });


            const slotValues = Object.values(slots);
            const dateStart = slotValues.reduce(
                (min, slot) => (slot.date < min ? slot.date : min),
                slotValues[0].date,
            );
            const dateEnd = slotValues.reduce(
                (max, slot) => (slot.date > max ? slot.date : max),
                slotValues[0].date,
            );

            axios
                .post(url, {
                    taskId: taskId,
                    timings: {
                        dateStart: dateStart,
                        dateEnd: dateEnd,
                        timeStart: slot.time_start,
                        timeEnd: slot.time_end,
                    },
                    assignees: {
                        assignedTeams: assignedTeams,
                        assignedPersons: assignedPersons,
                        assignedEquipments: assignedEquipments,
                        linkedAssignees: true,
                    },
                    updateRepeatedSlotSetting: this.updateRepeatedSlotSetting,
                })
                .then((response) => {
                    emitter.emit('planning-drop-handled');
                    switch (this.mode) {
                        case 'project':
                            const taskIds = response.data.taskIds;
                            this.requestItemSlots({ itemsIds: taskIds });
                            break;
                        case 'person':
                            const personIds = response.data.personIds;
                            this.requestItemSlots({ itemsIds: personIds });
                            break;
                        case 'equipment':
                            const equipmentIds = response.data.equipmentIds;
                            this.requestItemSlots({ itemsIds: equipmentIds });
                            break;
                        case 'team':
                            const teamIds = response.data.teamIds;
                            this.requestItemSlots({ itemsIds: teamIds });
                            break;
                    }
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        // Reset the changes
                        const errorMessage = trans("You don't have rights for this project");
                        emitter.emit('hide-slot-hover-info');
                        emitter.emit('hide-day-hover-info');
                        emitter.emit('show-message-modal', {
                            messageHtml: errorMessage,
                        });
                        this.resetDragChanges();
                    }
                });
            if (this.optionConfirmedRepeatedSlotsInModal) {
                this.dragInfo.date = null;
                this.dragInfo.itemId = null;
                this.optionConfirmedRepeatedSlotsInModal = false;
                this.updateRepeatedSlotSetting = null;
            }
        },
        toggleControlPanelExtra(componentName, title) {
            this.controlPanelExtra.title = title;
            if (!this.controlPanelExtra.show) {
                this.controlPanelExtra.show = !this.controlPanelExtra.show;
            }
            if (this.controlPanelExtra.show) {
                this.controlPanelExtra.component = componentName;
            } else {
                this.controlPanelExtra.component = null;
            }
        },
        openPlanningForm() {
            let eventObject = {
                dateStart: this.dates[0].formatted,
                dateEnd: this.dates[0].formatted,
            };

            emitter.emit('open-planning-form', eventObject);
        },
        handleMouseOver(event) {
            const target = event.target;
            if (!target.classList.contains('slot-info')) {
                emitter.emit('hide-slot-hover-info');
            }
            if (!target.classList.contains('day') && !target.classList.contains('day-hour')) {
                emitter.emit('hide-day-hover-info');
            }
        },
        updateRepeatedSlots(value) {
            this.updateRepeatedSlotSetting = value;
            this.optionConfirmedRepeatedSlotsInModal = true;
            this.updateRepeatedSlotsModal.active = false;
            this.handleDrop();
        },
        resetDragChanges() {
            this.updateRepeatedSlotsModal.active = false;
            switch (this.$store.state.planning.mode) {
                case 'project':
                    this.setDraggingData({
                        date: this.dragStartInfo.draggedSlot.date,
                        itemId: this.dragStartInfo.draggedSlot.taskId,
                        dragOverTime: this.dragStartInfo.draggedSlot.dragTime,
                    });
                    break;
                case 'team':
                    this.setDraggingData({
                        date: this.dragStartInfo.draggedSlot.date,
                        itemId: this.dragStartInfo.draggedSlot.teamId,
                        dragOverTime: this.dragStartInfo.draggedSlot.dragTime,
                    });
                    break;
                case 'person':
                    this.setDraggingData({
                        date: this.dragStartInfo.draggedSlot.date,
                        itemId: this.dragStartInfo.draggedSlot.personId,
                        dragOverTime: this.dragStartInfo.draggedSlot.dragTime,
                    });
                    break;
            }
        },

        startScroll() {
            if (!this.expose) {
                return;
            }

            const el = this.$refs.calendar.$el;

            if (el.scrollTop === 0) {
                if (!this.delayAtTop) {
                    // Start a delay timer when at the top
                    this.delayAtTop = true;
                    this.delayTimer = setTimeout(() => {
                        this.delayAtTop = false;
                        this.scroll();
                    }, 5000); // Delay for 5 seconds
                }
            } else {
                this.scroll(); // Scroll immediately if not at the top
            }
        },
        scroll() {
            const el = this.$refs.calendar.$el;
            el.scrollTop += 1;

            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                if (!this.reloadCooldown) {
                    this.reloadCooldown = true;
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            location.reload(true); // Force a reload from the server
                        }, 5000);
                    });
                    setTimeout(() => {
                        this.reloadCooldown = false; // Reset cooldown after 10 seconds
                    }, 10000); // 10-second cooldown
                }
            }
        },
        addScrollEventListener() {
            this.$nextTick(() => {
                const el = this.$refs.calendar?.$el;

                if (el) {
                    // To make sure it's not added multiple times
                    el.removeEventListener('scroll', this.handleScroll);
                    el.addEventListener('scroll', this.handleScroll);
                }
            });
        },
    },
    mounted() {
        this.initCalendar({ calendarHeight: this.$refs.calendar.$el.offsetHeight });
        this.loadPlanningFilter();

        this.addScrollEventListener();

        emitter.on('hide-control-panel-extra-component', () => {
            this.controlPanelExtra.show = false;
        });

        if( this.expose ){
            // Not best way but works
            setTimeout(() => {
                this.changeSort({ sort: 'department-title', sortOrder: 'ASC'});
            }, 1000);
        }
        setInterval(this.startScroll, 50);

    },
    watch:{
        mode: {
            handler() {
                this.addScrollEventListener();
            },
        }
    }
};
</script>

<style lang="scss">
.planning-wrapper {
    height: calc(100vh - 50px);
    width: calc(100% + 30px);

    margin-left: -15px;
    margin-right: -15px;
    margin-top: -30px;

    &.expose {
        margin: 0;
        height: 100vh;
        width: 100%;
        pointer-events: none;
    }

    display: flex;
    flex-wrap: nowrap;
}
.right-control-panel {
    display: flex;
    flex-wrap: nowrap;
}
.planning-button-bar {
    display: flex;
    flex-direction: column;
    .bar-button {
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background-color: #6e7c7c;
        color: #fff;
        font-size: 1.3em;
        cursor: pointer;
        position: relative;
        &.primary {
            background-color: var(--main-color);
            &:hover {
                background-color: var(--main-color);
            }
        }
        &.active {
            background-color: var(--main-color);
            &:hover {
                background-color: var(--main-color);
            }
        }
        &:hover {
            background-color: #7a8989;
        }

        .background-icon {
            position: absolute;
            font-size: 15px;
            top: 10px;
            left: 28px;
        }
    }
}

.bar-date-button {
    flex-grow: 2;
    font-size: 1.5em;
    background-color: #efefef;
    &:hover {
        background-color: #fcfcfc;
    }
}
.calendar {
    /*Changes wihtin row will not effect any outside elements*/
    contain: layout;
    position: relative;
    overflow-x: scroll;
    overflow-y: scroll;
    height: 100%;
    -webkit-overflow-scrolling: touch;
}

.vue-recycle-scroller__item-wrapper {
    overflow: visible;
}

.vue-recycle-scroller__slot {
    // display: inline-flex;
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    top: 0;
    z-index: 4;
    background: #fff;
    border-bottom: 1px solid #ccc;
}
.cursor-grabbing *:active {
    cursor: move !important;
}

.drag-info-wrapper {
    position: absolute;
    /* display: none; */
}
.drag-info-wrapper .drag-info {
    width: 1px;
    height: 1px;
}
.inline-flex {
    display: inline-flex;
    background: #fff;
}
</style>
